import React from 'react'
import PropTypes from 'prop-types'

const SearchHeader = ({ content }) => {
  return (
    <header>
      <h1>{content['Heading']}</h1>
      <p className="-lead">{content['Description']}</p>
    </header>
  )
}

SearchHeader.propTypes = {
  content: PropTypes.object,
}

export default SearchHeader
